import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UrlKeys } from '../enums/urls.enum';
import { AuthService } from '../services/auth.service';

export const appGuard: CanActivateFn = ():
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  return inject(AuthService).isLogged() && environment.platform !== 'web'
    ? true
    : inject(Router).createUrlTree([`/${UrlKeys.HOME}`]);
};
